import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { adminLogout } from '../../service/adminService';

const Logout = () => {
	const history = useHistory()
	useEffect(() => {
		(async() => {
			try {
				await adminLogout();
				localStorage.removeItem('token');
				history.replace('/login');
			} catch (err) {
				if(err.response && err.response.status === 401)
				history.replace('/login')
			}
		})();
	})
	return ( null );
}
 
export default Logout;